import {
  IAnalyticsDashboardArgument,
  IAnalyticsEventDashboard,
  IDashboardEventSubParams,
} from './types';
import { getDashboardEventProperties } from './utils';

export const dashboardCreated = (
  dashboardInstanceOrTemplate: IAnalyticsDashboardArgument,
): IAnalyticsEventDashboard => {
  return {
    eventName: 'Dashboard Created',
    ...getDashboardEventProperties(dashboardInstanceOrTemplate),
  };
};

export const dashboardViewed = (
  dashboardInstanceOrTemplate: IAnalyticsDashboardArgument,
  subParams?: IDashboardEventSubParams,
): IAnalyticsEventDashboard => {
  return {
    eventName: 'Dashboard Viewed',
    ...getDashboardEventProperties(dashboardInstanceOrTemplate, subParams),
  };
};

export const dashboardUpdated = (
  dashboardInstanceOrTemplate: IAnalyticsDashboardArgument,
): IAnalyticsEventDashboard => {
  return {
    eventName: 'Dashboard Updated',
    ...getDashboardEventProperties(dashboardInstanceOrTemplate),
  };
};

export const dashboardFilterUpdated = (
  dashboardInstanceOrTemplate: IAnalyticsDashboardArgument,
): IAnalyticsEventDashboard => {
  return {
    eventName: 'Dashboard Filter Updated',
    ...getDashboardEventProperties(dashboardInstanceOrTemplate),
  };
};

export const dashboardScheduleCreated = (
  dashboardInstanceOrTemplate: IAnalyticsDashboardArgument,
): IAnalyticsEventDashboard => {
  return {
    eventName: 'Dashboard Schedule Created',
    ...getDashboardEventProperties(dashboardInstanceOrTemplate),
  };
};

export const dashboardUserRefreshed = (
  dashboardInstanceOrTemplate: IAnalyticsDashboardArgument,
): IAnalyticsEventDashboard => {
  return {
    eventName: 'Dashboard User Refreshed',
    ...getDashboardEventProperties(dashboardInstanceOrTemplate),
  };
};

export const dashboardCommentCreated = (
  dashboardInstanceOrTemplate: IAnalyticsDashboardArgument,
  subParams?: IDashboardEventSubParams,
): IAnalyticsEventDashboard => {
  return {
    eventName: 'Dashboard Comment Created',
    ...getDashboardEventProperties(dashboardInstanceOrTemplate, subParams),
  };
};
